import permission, { checkPermission } from "./permission";
var install = function install(Vue) {
  Vue.directive("permission", permission);
  Vue.prototype.checkPermission = checkPermission;
};
if (window.Vue) {
  window["permission"] = permission;
  window["checkPermission"] = checkPermission;
  Vue.use(install); // eslint-disable-line
}

permission.install = install;
export default permission;